export function CommunityResults({ d }) {
  const rows = [...d.teorie].sort((a, b) => (b.percentuale || 0) - (a.percentuale || 0));
  const n = d.totale_voti;
  return (
    <section data-testid="community-results" aria-labelledby="community-results-title" className="space-y-5 rounded-[18px] border border-[var(--luma-line)] bg-white p-[22px] sm:p-7">
      <div className="space-y-1">
        <h3 id="community-results-title" className="text-xl font-extrabold sm:text-2xl">Le scelte della community</h3>
        <p className="text-sm text-[var(--luma-muted)]" data-testid="community-results-total">
          {n} {n === 1 ? "scelta confermata" : "scelte confermate"} finora. Mostrano cosa pensa chi ha votato qui, non una risposta ufficiale.
        </p>
      </div>
      <ul className="space-y-4">
        {rows.map((t) => {
          const mine = d.mio_voto === t.id;
          return (
            <li key={t.id} data-testid={`result-row-${t.id}`}>
              <div className="flex items-start justify-between gap-3 text-[15px]">
                <span className={`min-w-0 ${mine ? "font-bold text-[var(--luma-action)]" : "font-semibold"}`}>{t.titolo}{mine && <span className="ml-1 text-xs">· la tua scelta</span>}</span>
                <span data-testid={`option-percent-${t.id}`} className="shrink-0 font-extrabold tabular-nums">{t.percentuale}%</span>
              </div>
              <div className="mt-2 h-2 rounded-full bg-[var(--luma-bg)]" aria-hidden="true">
                <div className="h-2 rounded-full transition-[width] duration-700" style={{ width: `${t.percentuale}%`, background: mine ? "var(--luma-action)" : "var(--luma-cyan)" }} />
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
